export const ROUTES = {
  RANKING: '/ranking',
  TRADE: '/trade',
}